<template>
    <div :class="['reportPanel-div']">
        <i-col span="7">
            <div :class="['list-form', skinClass]">
                <span :class="['iconStyle']">
                   <span :class="['iconArea']">
                        <Icon :type="icon" size="24"/>
                   </span>
                </span>
                <span class="text">{{title}}</span>
            </div>
        </i-col>		
    </div>
</template>
<script>
export default {
    name: 'CsReport',
    props: ['icon', 'title','skinClass', 'iconColor'],
    mounted () {     
    }
}
</script>



// WEBPACK FOOTER //
// src/components/report/report.vue